// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 674) return "static/chunks/674-fae043fca9fbfac7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8":"6be19fdcff7eada4","280":"1ec80f552a00ea22"}[chunkId] + ".js";
};